import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import User from '@/repositories/data/User';

export default class UserApi {
    private readonly client: HttpClient;
    private readonly baseUrl: string;
    private readonly logoutEndpoint: string;

    constructor(client: HttpClient, apiEndpoint: string, logoutEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint;
        this.logoutEndpoint = logoutEndpoint;
    }

    public findSelf(): Observable<User | null> {
        return this.client.get('self', { baseUrl: this.baseUrl });
    }

    public logout(): Observable<{ logoutUrl: string }> {
        return this.client.post(this.logoutEndpoint);
    }
}
